function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-link_svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.627 1.373a4.687 4.687 0 00-6.63 0L8.08 5.29c-1.893 1.893-1.718 4.91 0 6.629.288.287.606.522.942.715l.715-.715c.47-.47.304-1.018.296-1.413a2.261 2.261 0 01-.296-.245c-.881-.881-.921-2.393 0-3.314l3.918-3.918a2.346 2.346 0 013.315 0c.914.914.914 2.4 0 3.315l-2.59 2.59c.075.414.524 1.395.293 3.014.011-.01.025-.018.036-.03l3.918-3.917a4.687 4.687 0 000-6.63z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.224 7.777a4.462 4.462 0 00-.942-.715l-.715.715c-.47.469-.304 1.017-.296 1.413.103.073.203.151.296.244.881.882.921 2.393 0 3.314L6.345 16.97c-.914.914-2.4.914-3.314 0a2.346 2.346 0 010-3.315l2.893-2.893c-.075-.414-.524-1.396-.293-3.015-.011.011-.025.018-.036.03l-4.222 4.221a4.688 4.688 0 006.63 6.63l4.22-4.222c1.86-1.859 1.758-4.873 0-6.63z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-link_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgIconLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconLink;